import { create } from "zustand";

const listStore = (set) => ({
  lists: [],
  setLists: (newData) => set({ lists: newData }),

  isChild: false,
  setIsChild: (newData) => set({ isChild: newData }),

  listingLoad: false,
  setListingLoad: (newData) => set({ listingLoad: newData }),
  
  currentList: null,
  setCurrentList: (newData) => set({ currentList: newData }),

  loadProfile: false,
  setLoadProfile: (newData) => set({ loadProfile: newData }),

  activeList: null,
  setActiveList: (newData) => set({ activeList: newData }),

  activeBlacklist: null,
  setActiveBlacklist: (newData) => set({ activeBlacklist: newData }),

  activeUnsub: null,
  setActiveUnsub: (newData) => set({ activeUnsub: newData }),

  modelMinimized: null,
  setModelMinimized: (newData) => set({ modelMinimized: newData }),

  activeModel: null,
  setActiveModel: (newData) => set({ activeModel: newData }),
});

export const useListStore = create(listStore);
